import { initializeApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import {  getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyB-PeHPbX-l-JP_Ffkot3iKNB8pHkEcjuQ",
    authDomain: "vivachefs.firebaseapp.com",
    projectId: "vivachefs",
    storageBucket: "vivachefs.appspot.com",
    messagingSenderId: "301254041707",
    appId: "1:301254041707:web:8c9d632bf9eedb3945d12e",
    measurementId: "G-0K74YFL9ZX"
};

const app = initializeApp(firebaseConfig);
const auth: Auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app)
const messaging = getMessaging(app);
const functions = getFunctions(app)

if ("serviceWorker" in navigator && "PushManager" in window) {
    // Initialize Firebase Messaging
    const messaging = getMessaging(app);
  
    // Example: Handle incoming messages
    onMessage(messaging, (payload) => {
      console.log("Message received: ", payload);
      // Handle the message here
    });
  } else {
    console.error("Browser does not support Firebase Messaging.");
  }
// export { auth, RecaptchaVerifier, messaging, getToken };
export { auth, getToken, db,app, storage, functions, messaging  };
